const red = {
  50: "#ffeaed",
  100: "#ffcad0",
  200: "#f19596",
  300: "#e76b6d",
  400: "#f04748",
  500: "#f5312c",
  600: "#e6252b",
  700: "#d41826",
  800: "#c70b1e",
  900: "#b90011",
};
export default red;
